import { UseFormReturn } from 'react-hook-form';

import { Article } from '@work4all/models/lib/Classes/Article.entity';

import { useFormUpdate } from '../../../../../containers/mask-overlays/mask-overlay/utils/use-form-update';
import { ProjectHourBillingOverlayFormValue } from '../types';

export const useProjectHourBillingOverlayFormUpdate = (
  form: UseFormReturn<ProjectHourBillingOverlayFormValue>
) => {
  useFormUpdate(
    {
      'settings.billingBy': () => {
        const settings = form.getValues('settings');
        const filters = form.getValues('filters');

        return {
          settings: {
            ...settings,
            converAllPositionsFromOrderConformation: false,
            headerShowOrderReference: false,
            headerShowProjectReference: false,
            headerShowTimespan: false,
            positionShowOrderReference: false,
            customerCodes: [],
            orderConfirmationCodes: [],
          },
          filters: {
            ...filters,
            onlyCompletedTickets: false,
          },
        };
      },
      article: (article: Article) => {
        const settings = form.getValues('settings');

        return {
          settings: {
            ...settings,
            articleCode: article?.id,
          },
        };
      },
    },
    form
  );
};
